import React from 'react';
// import CustomizedLabel from './CustomizedLable';
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';


const StanceBeamDoubleBarChart = ({ chartData, firstBarColor, secondBarColor }) => (
    <ResponsiveContainer width="100%" height={200}>
        <BarChart data={chartData}
            margin={{ top: 10, right: 0, left: -25, bottom: 0 }}>
            <XAxis dataKey="x" />
            <YAxis />
            <CartesianGrid strokeDasharray="0 3" vertical={false} />
            <Tooltip />
            <Legend />
            {/* <Bar dataKey="pv" fill="#3367d6" /> */}

            <Bar dataKey={Object.keys(chartData[0])[1]} fill={firstBarColor} />
            <Bar dataKey={Object.keys(chartData[0])[2]} fill={secondBarColor} />
            {/* <Bar dataKey="Max Bat Speed" fill={barColor} /> */}
        </BarChart>
    </ResponsiveContainer>
);

export default StanceBeamDoubleBarChart;